import React from 'react';

const ExportLink = ({
  titleTag = 'External Link',
  width = 24,
  fill = '#ffffff',
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 20"
    style={{
      width,
      ...style,
    }}
  >
    {titleTag && <title>{titleTag}</title>}
    <path
      fill={fill}
      d="M11.6139 14.233C11.6369 14.2601 11.6663 14.2821 11.6999 14.2972C11.7334 14.3123 11.7703 14.3202 11.8076 14.3202C11.845 14.3202 11.8818 14.3123 11.9154 14.2972C11.9489 14.2821 11.9783 14.2601 12.0013 14.233L15.4452 10.2074C15.5713 10.0597 15.4575 9.84091 15.2515 9.84091H12.973V0.227273C12.973 0.102273 12.8623 0 12.727 0H10.8821C10.7468 0 10.6361 0.102273 10.6361 0.227273V9.83807H8.36377C8.15775 9.83807 8.04398 10.0568 8.17005 10.2045L11.6139 14.233ZM23.0616 13.2386H21.2167C21.0814 13.2386 20.9707 13.3409 20.9707 13.4659V17.8409H2.64452V13.4659C2.64452 13.3409 2.53382 13.2386 2.39853 13.2386H0.553606C0.418312 13.2386 0.307617 13.3409 0.307617 13.4659V19.0909C0.307617 19.5938 0.747323 20 1.29157 20H22.3237C22.8679 20 23.3076 19.5938 23.3076 19.0909V13.4659C23.3076 13.3409 23.1969 13.2386 23.0616 13.2386Z"
    />
  </svg>
);

export default ExportLink;
